import { assertFormGqlOperation, UseFormReturn } from '@graphcommerce/react-hook-form'
import { Trans } from '@lingui/react'
import { Switch } from '@mui/material'

type FreightFieldValues = {
  residential_delivery?: boolean
  limited_access_delivery?: boolean
}

type AdditionalFieldProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: UseFormReturn<any>
}

export function AdditionalFields(props: AdditionalFieldProps) {
  const { form } = props
  assertFormGqlOperation<FreightFieldValues>(form)

  const { watch, register, setValue } = form

  return (
    <div className='grid w-full grid-cols-[10fr_15fr_75fr] items-center'>
      <span>{watch('residential_delivery') === true ? 'Yes' : 'No'}</span>
      <Switch
        checked={watch('residential_delivery')}
        {...register('residential_delivery')}
        onChange={(e) => {
          console.log('e.target.checked', e.target.checked)
          if (e.target.checked) setValue('limited_access_delivery', false)
          setValue('residential_delivery', e.target.checked)
        }}
      />
      <span className='Type-Large-Medium'>
        <Trans id='Residential Delivery*' />
      </span>
    </div>
  )
}
